import { BonusSettlementsDetailApi } from '../detail/api/bonus-settlements-detail-api';
import { BonusSettlementsOverviewApi } from '../overview/api/bonus-settlements-overview-api';

export class BonusSettlementsApi {
    constructor(protected baseUrl: string) {
        this.BonusSettlementsOverview = new BonusSettlementsOverviewApi(this.baseUrl);
        this.BonusSettlementsDetail = new BonusSettlementsDetailApi(this.baseUrl);
    }

    public BonusSettlementsOverview: BonusSettlementsOverviewApi;
    public BonusSettlementsDetail: BonusSettlementsDetailApi;
}
